import { render, staticRenderFns } from "./SlipUploadModal.vue?vue&type=template&id=9986b5a2&scoped=true"
import script from "./SlipUploadModal.vue?vue&type=script&lang=js"
export * from "./SlipUploadModal.vue?vue&type=script&lang=js"
import style0 from "./SlipUploadModal.vue?vue&type=style&index=0&id=9986b5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9986b5a2",
  null
  
)

export default component.exports